const removeFeed = {
  marginBottom: '10px',
};

export default { removeFeed };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/components/Options/style.js